export default "/images/paprikadesign.png?6bf4099021e4d446b4e3605fc2d2cc76";